import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';

const AtelierValidationPage = () => {
  // Fonction pour obtenir le chemin des images
  const getImagePath = (fileName) => {
    if (!fileName || fileName.trim() === '') return null;
    
    const cleanName = fileName.trim();
    const extensions = ['.jpg', '.jpeg', '.png', '.webp', '.JPG', '.JPEG', '.PNG'];
    const hasExtension = extensions.some(ext => cleanName.endsWith(ext));
    
    if (hasExtension) {
      return `/assets/validation-atelier/${cleanName}`;
    } else {
      return `/assets/validation-atelier/${cleanName}.png`;
    }
  };

  // Images pour la galerie
  const images = [
    { src: 'image6presentation.jpeg', title: 'Ouverture de l\'atelier par Mr NDAYISENGA Modeste', type: 'ouverture' },
    { src: 'image13.jpeg', title: 'Modérateur de l\'atelier', type: 'moderateur' },
    { src: 'image11.jpeg', title: 'Participants - vue d\'ensemble', type: 'public' },
    { src: 'image14.jpeg', title: 'Échanges entre participants', type: 'public' },
    { src: 'photodefamille4.jpeg', title: 'Photo de famille des participants', type: 'famille' },
  ];

  // Objectifs de la stratégie validée (contenu validé lors de l'atelier)
  const objectifsStrategie = [
    "Accroître la visibilité et l'accessibilité des données statistiques produites par l'INSBU et l'ensemble du SSN",
    "Renforcer la culture statistique des citoyens, des décideurs et des acteurs du développement",
    "Améliorer l'utilisation des données dans la planification, le suivi-évaluation des politiques publiques et la prise de décision",
    "Diversifier les canaux de diffusion et adapter les messages aux différentes cibles",
    "Contribuer à la réalisation de la Vision Burundi 2040-2060 à travers une gouvernance basée sur des données probantes"
  ];

  return (
    <div style={styles.container}>
      <NavigationBar />
      
      <main style={styles.main}>
        {/* En-tête avec titre et informations */}
        <header style={styles.header}>
          <div style={styles.projectBanner}>
            <span style={styles.projectTag}>INSBU</span>
            <span style={styles.financeTag}>Système Statistique National (SSN)</span>
          </div>
          
          <h1 style={styles.title}>
            Atelier de validation de la stratégie de communication du Système Statistique National (SSN)
          </h1>
          
          <div style={styles.metaInfo}>
            <span style={styles.date}>Vendredi 08 mai 2026</span>
            <span style={styles.location}>City Hill Hotel, Bujumbura</span>
          </div>
        </header>

        {/* Section 1 : Contexte et ouverture */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>
            <span style={styles.sectionNumber}>01</span>
            Contexte et ouverture des travaux
          </h2>
          
          <p style={styles.paragraph}>
            Le vendredi 08 mai 2026, l'Institut National de la Statistique du Burundi (INSBU) a organisé un atelier de validation de la stratégie de communication du Système Statistique National (SSN). Les activités se sont déroulées au City Hill Hotel, à Bujumbura, et ont été ouvertes par <strong>Mr NDAYISENGA Modeste</strong>, Directeur en charge de la communication à l'INSBU.
          </p>
          
          <p style={styles.paragraph}>
            Dans son discours de bienvenue, Mr NDAYISENGA Modeste a indiqué que cet atelier intervient au moment où, dans les pays membres de la Communauté de l'Afrique de l'Est (EAC), toute stratégie nationale tend à être en harmonie avec les lignes directrices tracées par la communauté. Il a fait savoir que l'objectif commun au sein de l'EAC est de transformer les résultats complexes des statistiques produites en informations claires et exploitables, car <strong>"les statistiques inutilisées sont des statistiques inutiles"</strong>.
          </p>
          
          <p style={styles.paragraph}>
            Mr NDAYISENGA Modeste a rappelé que l'ambition de l'INSBU en validant cette stratégie est de connaître la position de l'INSBU en matière de communication statistique et de construire une compréhension commune de la manière d'atteindre les différentes catégories d'utilisateurs des données statistiques. Il a terminé son allocution en remerciant tous les partenaires, animateurs et équipes de soutien pour la réussite de l'organisation de l'atelier.
          </p>

          {/* Image d'ouverture */}
          <div style={styles.featuredImageContainer}>
            <img 
              src={getImagePath('image6presentation.jpeg')} 
              alt="Ouverture de l'atelier par Mr NDAYISENGA Modeste"
              style={styles.featuredImage}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = '/assets/placeholder-event.jpg';
              }}
            />
            <p style={styles.imageCaption}>Mr NDAYISENGA Modeste, Directeur en charge de la communication à l'INSBU, ouvrant les travaux</p>
          </div>
        </section>

        {/* Section 2 : Objectifs de l'atelier */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>
            <span style={styles.sectionNumber}>02</span>
            Objectifs de l'atelier
          </h2>
          
          <div style={styles.objectivesAtelierContainer}>
            <div style={styles.objectiveAtelierCard}>
              <div style={styles.objectiveAtelierIcon}>🎯</div>
              <p>Présenter les résultats du diagnostic et les axes stratégiques proposés pour la communication statistique</p>
            </div>
            <div style={styles.objectiveAtelierCard}>
              <div style={styles.objectiveAtelierIcon}>💬</div>
              <p>Recueillir les observations, recommandations et contributions des parties prenantes</p>
            </div>
            <div style={styles.objectiveAtelierCard}>
              <div style={styles.objectiveAtelierIcon}>✅</div>
              <p>Valider collectivement la stratégie de communication du Système Statistique National</p>
            </div>
            <div style={styles.objectiveAtelierCard}>
              <div style={styles.objectiveAtelierIcon}>🌍</div>
              <p>Harmoniser l'approche avec les lignes directrices de la Communauté de l'Afrique de l'Est (EAC)</p>
            </div>
          </div>
        </section>

        {/* Section 3 : Présentation de la consultante */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>
            <span style={styles.sectionNumber}>03</span>
            Présentation du diagnostic et des axes stratégiques
          </h2>
          
          <p style={styles.paragraph}>
            Après le discours d'ouverture, la consultante a présenté les résultats du diagnostic de la communication statistique actuelle au sein du SSN, ainsi que les axes stratégiques proposés pour la nouvelle stratégie. La présentation a couvert :
          </p>
          
          <ul style={styles.customList}>
            <li>Les forces et faiblesses du système actuel de communication statistique</li>
            <li>Les populations cibles (autorités, décideurs, médias, société civile, universités, citoyens)</li>
            <li>Les messages clés adaptés à chaque cible</li>
            <li>Les canaux de diffusion prioritaires (site web, réseaux sociaux, médias locaux, bulletins, infographies)</li>
            <li>Les axes stratégiques à court, moyen et long terme</li>
          </ul>

          {/* Image du modérateur */}
          <div style={styles.imageRow}>
            <div style={styles.imageWrapper}>
              <img 
                src={getImagePath('image13.jpeg')} 
                alt="Modérateur de l'atelier"
                style={styles.inlineImage}
                onError={(e) => { e.target.onerror = null; e.target.src = '/assets/placeholder-person.jpg'; }}
              />
              <p style={styles.imageCaption}>Modérateur de l'atelier</p>
            </div>
          </div>
        </section>

        {/* Section 4 : Contributions des participants */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>
            <span style={styles.sectionNumber}>04</span>
            Contributions et échanges participatifs
          </h2>
          
          <p style={styles.paragraph}>
            Les participants à l'atelier, représentant diverses institutions publiques, partenaires techniques et financiers, médias et organisations de la société civile, ont ensuite fourni des contributions enrichissantes dans le but d'améliorer le fond et la forme de la stratégie de communication ainsi que la communication statistique en soi au sein du SSN.
          </p>
          
          <p style={styles.paragraph}>
            Parmi les principales recommandations émises figurent :
          </p>
          
          <div style={styles.recommendationsGrid}>
            <div style={styles.recommendationCard}>
              <div style={styles.recommendationIcon}>📢</div>
              <p>Renforcer l'utilisation des langues nationales (kirundi) dans tous les supports</p>
            </div>
            <div style={styles.recommendationCard}>
              <div style={styles.recommendationIcon}>📱</div>
              <p>Développer des applications mobiles et des services SMS pour atteindre les zones rurales</p>
            </div>
            <div style={styles.recommendationCard}>
              <div style={styles.recommendationIcon}>🏫</div>
              <p>Intégrer la culture statistique dans les programmes scolaires et universitaires</p>
            </div>
            <div style={styles.recommendationCard}>
              <div style={styles.recommendationIcon}>🤝</div>
              <p>Créer des comités locaux de relais statistique au niveau des communes et collines</p>
            </div>
          </div>

          {/* Images du public */}
          <div style={styles.imageRow}>
            <div style={styles.imageWrapper}>
              <img 
                src={getImagePath('image11.jpeg')} 
                alt="Participants à l'atelier - vue 1"
                style={styles.inlineImage}
                onError={(e) => { e.target.onerror = null; e.target.src = '/assets/placeholder-audience.jpg'; }}
              />
              <p style={styles.imageCaption}>Participants - vue d'ensemble</p>
            </div>
            <div style={styles.imageWrapper}>
              <img 
                src={getImagePath('image14.jpeg')} 
                alt="Participants à l'atelier - vue 2"
                style={styles.inlineImage}
                onError={(e) => { e.target.onerror = null; e.target.src = '/assets/placeholder-audience.jpg'; }}
              />
              <p style={styles.imageCaption}>Échanges entre participants</p>
            </div>
          </div>
        </section>

        {/* Section 5 : Résultats - Objectifs de la stratégie validée */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>
            <span style={styles.sectionNumber}>05</span>
            Résultats : objectifs de la stratégie validée
          </h2>
          
          <p style={styles.paragraph}>
            À l'issue des échanges et des contributions, la stratégie de communication du SSN a été validée par l'ensemble des participants. Cette stratégie vise à :
          </p>
          
          <div style={styles.objectivesList}>
            {objectifsStrategie.map((objectif, index) => (
              <div key={index} style={styles.objectiveItem}>
                <span style={styles.objectiveNumber}>{index + 1}.</span>
                <span>{objectif}</span>
              </div>
            ))}
          </div>
        </section>

        {/* Section 6 : Photo de famille et clôture */}
        <section style={styles.photoFamilySection}>
          <h2 style={styles.sectionTitle}>
            <span style={styles.sectionNumber}>06</span>
            Clôture et photo de famille
          </h2>
          
          <p style={styles.paragraph}>
            L'atelier s'est achevé dans une ambiance de collaboration et d'engagement partagé. Tous les participants ont salué la qualité des échanges et la pertinence des orientations retenues. Une photo de famille a immortalisé ce moment important pour l'avenir de la communication statistique au Burundi.
          </p>
          
          <div style={styles.familyImageContainer}>
            <img 
              src={getImagePath('photodefamille4.jpeg')} 
              alt="Photo de famille des participants à l'atelier de validation"
              style={styles.familyImage}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = '/assets/placeholder-group.jpg';
              }}
            />
            <p style={styles.imageCaption}>Photo de famille des participants – Atelier de validation de la stratégie de communication du SSN</p>
          </div>
        </section>

        {/* Section 7 : Remerciements */}
        <section style={styles.thanksSection}>
          <h2 style={styles.thanksTitle}>Remerciements</h2>
          <p style={styles.thanksText}>
            L'INSBU remercie chaleureusement tous les partenaires techniques et financiers, les experts, les animateurs, ainsi que l'ensemble des participants pour leur contribution active à la réussite de cet atelier. La validation de cette stratégie marque une étape décisive vers une communication statistique moderne, inclusive et efficace au service du développement du Burundi.
          </p>
        </section>
      </main>

      <Footer />
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    flex: 1,
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '20px',
    width: '100%',
  },
  header: {
    textAlign: 'center',
    marginBottom: '50px',
    paddingBottom: '25px',
    borderBottom: `2px solid #008D36`,
  },
  projectBanner: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    marginBottom: '20px',
  },
  projectTag: {
    backgroundColor: '#E30613',
    color: 'white',
    padding: '8px 20px',
    borderRadius: '20px',
    fontSize: '0.9rem',
    fontWeight: 'bold',
  },
  financeTag: {
    backgroundColor: '#008D36',
    color: '#f5f5f5',
    padding: '8px 20px',
    borderRadius: '20px',
    fontSize: '0.9rem',
    fontWeight: 'bold',
  },
  title: {
    color: '#008D36',
    fontSize: '1.8rem',
    marginBottom: '15px',
    fontWeight: '600',
    lineHeight: 1.3,
    padding: '0 20px',
  },
  metaInfo: {
    display: 'flex',
    justifyContent: 'center',
    gap: '30px',
    marginBottom: '30px',
  },
  date: {
    padding: '8px 20px',
    backgroundColor: '#f0f0f0',
    borderRadius: '20px',
    fontSize: '1rem',
    fontWeight: '500',
  },
  location: {
    padding: '8px 20px',
    backgroundColor: '#f0f0f0',
    borderRadius: '20px',
    fontSize: '1rem',
    fontWeight: '500',
  },
  section: {
    marginBottom: '60px',
    padding: '30px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  },
  sectionTitle: {
    color: '#008D36',
    fontSize: '1.8rem',
    marginBottom: '25px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: '600',
  },
  sectionNumber: {
    backgroundColor: '#E30613',
    color: 'white',
    padding: '5px 15px',
    borderRadius: '4px',
    marginRight: '15px',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  paragraph: {
    marginBottom: '20px',
    textAlign: 'justify',
    fontSize: '1.1rem',
    lineHeight: 1.7,
    color: '#333',
  },
  customList: {
    marginBottom: '25px',
    paddingLeft: '25px',
    listStyleType: 'disc',
    lineHeight: 1.7,
    color: '#333',
  },
  featuredImageContainer: {
    marginTop: '30px',
    textAlign: 'center',
  },
  featuredImage: {
    maxWidth: '100%',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    marginBottom: '10px',
  },
  imageCaption: {
    fontSize: '0.85rem',
    color: '#666',
    marginTop: '8px',
    fontStyle: 'italic',
  },
  imageRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '30px',
    justifyContent: 'center',
    marginTop: '25px',
  },
  imageWrapper: {
    flex: '1 1 300px',
    textAlign: 'center',
  },
  inlineImage: {
    width: '100%',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  recommendationsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: '20px',
    marginTop: '20px',
    marginBottom: '25px',
  },
  recommendationCard: {
    backgroundColor: '#f0f8ff',
    padding: '20px',
    borderRadius: '8px',
    textAlign: 'center',
    border: '1px solid #008D36',
  },
  recommendationIcon: {
    fontSize: '2rem',
    marginBottom: '10px',
  },
  objectivesAtelierContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '20px',
    marginTop: '20px',
  },
  objectiveAtelierCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    borderLeft: '4px solid #E30613',
  },
  objectiveAtelierIcon: {
    fontSize: '2rem',
    flexShrink: 0,
  },
  objectivesList: {
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  objectiveItem: {
    display: 'flex',
    gap: '15px',
    alignItems: 'flex-start',
    fontSize: '1rem',
    lineHeight: 1.6,
    color: '#333',
    padding: '10px',
    backgroundColor: '#f9f9f9',
    borderRadius: '6px',
  },
  objectiveNumber: {
    fontWeight: 'bold',
    color: '#008D36',
    minWidth: '30px',
  },
  photoFamilySection: {
    marginBottom: '60px',
    padding: '30px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  },
  familyImageContainer: {
    textAlign: 'center',
    marginTop: '25px',
  },
  familyImage: {
    maxWidth: '100%',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  },
  thanksSection: {
    padding: '30px',
    backgroundColor: '#e8f5e9',
    borderRadius: '8px',
    textAlign: 'center',
    border: '1px solid #008D36',
    marginBottom: '40px',
  },
  thanksTitle: {
    color: '#008D36',
    fontSize: '1.6rem',
    marginBottom: '15px',
    fontWeight: '600',
  },
  thanksText: {
    fontSize: '1.05rem',
    lineHeight: 1.7,
    color: '#333',
  },
};

export default AtelierValidationPage;